export default {
  SELECT_PRODUCT: "SELECT_PRODUCT",
  CLEAR_PRODUCT: "CLEAR_PRODUCT",

  SET_USER_ID: "SET_USER_ID",
  SELECTED_DEFAULT_PRODUCT: "SELECTED_DEFAULT_PRODUCT",
  SET_DEFAULT_PRODUCT: "SET_DEFAULT_PRODUCT",

  VIEWER_READY: "VIEWER_READY",

  TOGGLE_HOURGLASS: "TOGGLE_HOURGLASS",

  LOGO_LOAD: "LOGO_LOAD",
  PRODUCTS_LOAD: "PRODUCTS_LOAD",

  GET_ALL_LOGOS: "GET_ALL_LOGOS",
  CLEAR_ALL_LOGOS: "CLEAR_ALL_LOGOS",
  //=========================================================2d mode

  SET_2D_LOADER: "SET_2D_LOADER",
  SET_2D_PRODUCT: "SET_2D_PRODUCT",
  CLEAR_2D_PRODUCT: "CLEAR_2D_PRODUCT",
  FETCH_2D_PRODUCT: "FETCH_2D_PRODUCT",
  FETCH_2D_PRODUCTS: "FETCH_2D_PRODUCTS",
  PRODUCT_2D_LOAD_SUCCESS: "PRODUCT_2D_LOAD_SUCCESS",

  CREATE_CANVAS_API: "CREATE_CANVAS_API",
  CLEAR_CANVAS_API: "CLEAR_CANVAS_API",

  PRODUCT_2D_SET_ACTIVE_PART: "PRODUCT_2D_SET_ACTIVE_PART",
  PRODUCT_2D_CLEAR_ACTIVE_PART: "PRODUCT_2D_CLEAR_ACTIVE_PART",
  PRODUCT_2D_SET_CANVAS_STATE: "PRODUCT_2D_SET_CANVAS_STATE",
  PRODUCT_2D_CLEAR_CANVAS_STATE: "PRODUCT_2D_CLEAR_CANVAS_STATE",
  PRODUCT_2D_SET_BASE_COLOR: "PRODUCT_2D_SET_BASE_COLOR",
  PRODUCT_2D_CLEAR_BASE_COLOR: "PRODUCT_2D_CLEAR_BASE_COLOR",

  P_2D_SET_LEFTWORKAREA_STATE: "P_2D_SET_LEFTWORKAREA_STATE",
  P_2D_CLEAR_LEFTWORKAREA_STATE: "P_2D_CLEAR_LEFTWORKAREA_STATE",

  P_2D_SET_ACTIVE_OBJECT: "P_2D_SET_ACTIVE_OBJECT",
  P_2D_CLEAR_ACTIVE_OBJECT: "P_2D_CLEAR_ACTIVE_OBJECT",

  P_2D_SET_ACTIVE_OBJECTS: "P_2D_SET_ACTIVE_OBJECTS",
  P_2D_CLEAR_ACTIVE_OBJECTS: "P_2D_CLEAR_ACTIVE_OBJECTS",

  SET_KEY: "",
  SET_OPTIONS: "SET_OPTIONS",

  GET_FB_DATA: "GET_FB_DATA",

  // ======================================================Constants for MixPanel
  CUSTOMIZER_STARTED: "CUSTOMIZER_STARTED",
  IMAGE_PLACED: "IMAGE_PLACED",
  TEXT_PLACED: "TEXT_PLACED",
  BASE_COLOR_CHANGED: "BASE_COLOR_CHANGED",
  PICE_COLOR_CHANGED: "PICE_COLOR_CHANGED",
  EXIT_WITH_ORDER: "EXIT_WITH_ORDER",
  QUIT: "QUIT",

 // ============================ Constants for PRODUCTS
 ADD_PRODUCT_ARRAY: "ADD_PRODUCT_ARRAY"

 //============================== TABS
}
